export default __webpack_public_path__ + "static/media/icon-search.3acf1ded.svg";